export const buttonRefreshPatternMatch = (s) => {
  // Define the regex pattern
  const pattern = /Refresh completed for button ID\s*:\s*(.+)/;

  // Search for the pattern in the input string
  const match = s.match(pattern);

  // If a match is found, return true and the captured group; otherwise, return false and an empty string
  if (match) {
    return [true, match[1]];
  }
  return [false, ''];
};
